<template>
  <div>
    <div :class="`wrapper-page${isMenuOpen ? '' : '-closeSidebar'}`">
      <!-- Mobile -->
      <PageSidebarMobile :show="isMenuOpen && currentDevice != 'desktop'" />

      <!-- Desktop -->
      <page-sidebar
        title="TRAVELCAB"
        :isMenuOpen="isMenuOpen"
        :tooltipType="tooltipType"
        @toggleMenu="toggleMenu"
        v-if="currentDevice == 'desktop'"
      >

        <template #custom-header>
          <img
            src="@/core/assets/images/layout/logo-admin-transparent.png"
            alt="Razzil"
            class="sidebar-logo"
          />
          <span class="sidebar-title w-50">TRAVELCAB</span>
        </template>

        <template #list-items>
          <!-- === AFFILIATE MENU === -->
          <template v-if="isAffiliate">
            <router-link
              :to="{ name: 'AffiliateDashboard' }"
              tag="li"
              exact-active-class="active"
              class="d-flex sidebar-item"
            >
              <div class="d-flex align-items-center">
                <span class="menu-icon"><i class="ri-dashboard-line"></i></span>
                <span class="sidebar-item-text">Dashboard</span>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'AffiliateRides' }"
              tag="li"
              exact-active-class="active"
              class="d-flex sidebar-item"
            >
              <div class="d-flex align-items-center">
                <span class="menu-icon"><i class="ri-car-line"></i></span>
                <span class="sidebar-item-text">Mis Viajes</span>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'AffiliatePassword' }"
              tag="li"
              exact-active-class="active"
              class="d-flex sidebar-item"
            >
              <div class="d-flex align-items-center">
                <span class="menu-icon"><i class="ri-lock-line"></i></span>
                <span class="sidebar-item-text">Cambiar contrasena</span>
              </div>
            </router-link>
          </template>

          <!-- === ADMIN MENU === -->
          <template v-else>
          <!-- Viajes -->
          <router-link
            :to="{ name: 'viajes-ride-list' }"
            tag="li"
            active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'viajes-item'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-car-line"></i>
              </span>
              <span class="sidebar-item-text">Viajes</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'viajes-item'"
                text="Viajes"
              />
            </div>
          </router-link>

          <!-- Tarifas -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/tarifas"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'tarifas'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('tarifas')
            "
          >
            <div class="d-flex flex-column justify-content-center sidebar-item-container">
              <div class="d-flex align-items-center justify-content-between w-100">
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'tarifas-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-price-tag-3-line"></i>
                  </span>
                  <span class="sidebar-item-text">Tarifas</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'tarifas-item'"
                    text="Tarifas"
                  />
                </div>
              </div>
              <span :class="`sidebar-item-description ${isCurrent('tarifas') ? 'active' : ''}`">
                Tarifario, Precios Base, Reglas
              </span>
            </div>
            <div v-if="isMenuOpen">
              <span v-if="isCurrent('tarifas')">
                <i class="ri-arrow-up-s-line"></i>
              </span>
              <span v-else>
                <i class="ri-arrow-down-s-line"></i>
              </span>
            </div>
          </router-link>

          <!-- Submenu tarifas -->
          <section>
            <ul :class="`sidebar-submenu ${isCurrent('tarifas') ? 'active' : ''} pl-0`">
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="tarifas-tarifario"
                text="Tarifario"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="tarifas-base-price-list"
                text="Precios Base"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="tarifas-price-rules"
                text="Reglas de Cálculo"
              ></sub-item>
            </ul>
          </section>

          <!-- Pasajeros -->
          <router-link
            :to="{ name: 'config-passenger-list' }"
            tag="li"
            exact-active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'config-passenger-list'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-user-line"></i>
              </span>
              <span class="sidebar-item-text">Pasajeros</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'config-passenger-list'"
                text="Pasajeros"
              />
            </div>
          </router-link>

          <!-- Afiliados -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/afiliados"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'afiliados'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('afiliados')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'afiliados-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-user-line"></i>
                  </span>

                  <span class="sidebar-item-text">Afiliados</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'afiliados-item'"
                    text="Afiliados"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('afiliados') ? 'active' : ''
                }`"
              >
                Lista, Categorías
              </span>
            </div>
            <div v-if="isMenuOpen">
              <span v-if="isCurrent('afiliados')">
                <i class="ri-arrow-up-s-line"></i>
              </span>
              <span v-else>
                <i class="ri-arrow-down-s-line"></i>
              </span>
            </div>
          </router-link>

          <!-- Submenu afiliados -->
          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('afiliados') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-affiliate-list"
                text="Lista"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-category-list"
                text="Categorías"
              ></sub-item>
            </ul>
          </section>

          <!-- Travelbot -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/travelbot"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'travelbot'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('travelbot')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'travelbot-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-robot-2-line"></i>
                  </span>

                  <span class="sidebar-item-text">Travelbot</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'travelbot-item'"
                    text="Travelbot"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('travelbot') ? 'active' : ''
                }`"
              >
                Black list
              </span>
            </div>
            <div v-if="isMenuOpen">
              <span v-if="isCurrent('travelbot')">
                <i class="ri-arrow-up-s-line"></i>
              </span>
              <span v-else>
                <i class="ri-arrow-down-s-line"></i>
              </span>
            </div>
          </router-link>

          <!-- Submenu travelbot -->
          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('travelbot') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="travelbot-black-list"
                text="Black List"
              ></sub-item>
            </ul>
          </section>

          <!-- Mantenimiento -->
          <router-link
            event=""
            tag="li"
            active-class="active"
            to="/config"
            class="sidebar-item d-flex align-items-center"
            @click.native.prevent="
              currentSubmenu === 'config'
                ? setCurrentSubmenu(null)
                : setCurrentSubmenu('config')
            "
          >
            <div
              class="d-flex flex-column justify-content-center sidebar-item-container"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div
                  class="d-flex"
                  @mouseover="tooltipType = 'config-item'"
                  @mouseleave="tooltipType = null"
                >
                  <span class="menu-icon">
                    <i class="ri-edit-line"></i>
                  </span>

                  <span class="sidebar-item-text">Mantenimiento</span>
                  <CustomTooltip
                    custom-class="tooltip-sidebar"
                    v-if="!isMenuOpen && tooltipType === 'config-item'"
                    text="Mantenimiento"
                  />
                </div>
              </div>
              <span
                :class="`sidebar-item-description ${
                  isCurrent('config') ? 'active' : ''
                }`"
              >
                Impulsadores, Líneas de gasto, Motivos de rechazo
              </span>
            </div>
            <div v-if="isMenuOpen">
              <span v-if="isCurrent('config')">
                <i class="ri-arrow-up-s-line"></i>
              </span>
              <span v-else>
                <i class="ri-arrow-down-s-line"></i>
              </span>
            </div>
          </router-link>

          <!-- Submenu mantenimiento -->
          <section>
            <ul
              :class="`sidebar-submenu ${
                isCurrent('config') ? 'active' : ''
              } pl-0`"
            >
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-user-list"
                text="Usuarios"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-vehicle-type-list"
                text="Tipo de Vehículos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-vehicle-list"
                text="Vehículos"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-driver-list"
                text="Conductores"
              ></sub-item>
              <sub-item
                :isMenuOpen="isMenuOpen"
                routeName="config-coupon-list"
                text="Cupones"
              ></sub-item>
            </ul>
          </section>

          <!-- Auditoría -->
          <router-link
            :to="{ name: 'audit-log' }"
            tag="li"
            exact-active-class="active"
            class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'audit-log'"
            @mouseleave.native="tooltipType = null"
          >
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-edit-line"></i>
              </span>

              <span class="sidebar-item-text">Auditoría</span>
              <CustomTooltip
                custom-class="tooltip-sidebar"
                v-if="!isMenuOpen && tooltipType === 'audit-log'"
                text="Auditoría"
              />
            </div>
          </router-link>
          </template><!-- /v-else admin menu -->
        </template>
      </page-sidebar>

      <div class="wrapper-page__content">
        <page-header />
        <div class="wrapper-page__inner">
          <b-container fluid>
            <slot></slot>
          </b-container>
        </div>
      </div>

      <page-footer />
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader";
import PageSidebarMobile from "./layout/PageSidebarMobile";

import {
  PageSidebar,
  CustomTooltip,
  PageFooter,
  SubItem
} from "wize-admin";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PageBase",
  components: {
    PageHeader,
    PageSidebarMobile,
    PageSidebar,
    PageFooter,
    CustomTooltip,
    SubItem
  },
  data() {
    return {
      matchMediaMd: window.matchMedia("(max-width: 768px)"),
      tooltipType: null,
      currentDevice: "desktop",
      lastWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      currentSubmenu: "app/getCurrentSubmenu",
      isMenuOpen: "app/isMenuOpen",
      isAffiliate: "auth/isAffiliate"
    })
  },
  methods: {
    calcResize() {
      this.setCurrentDevice();

      this.lastWidth = window.innerWidth;

      window.addEventListener("resize", () => {
        const currentWidth = window.innerWidth;

        if (currentWidth !== this.lastWidth) {
          this.setCurrentDevice();
          this.lastWidth = currentWidth;
        }
      });
    },
    setCurrentDevice() {
      if (screen.width < 992) {
        this.currentDevice = "mobile";
        this.setMenu(false);
      } else {
        this.currentDevice = "desktop";
        this.setMenu(true);
      }
    },
    isMatchMedia() {
      if (this.matchMediaMd.matches) {
        this.setMenu(false);
      } else {
        this.setMenu(true);
      }
    },
    isCurrent(submenu) {
      return this.currentSubmenu.includes(submenu);
    },
    ...mapMutations({
      setCurrentSubmenu: "app/setCurrentSubmenu",
      setMenu: "app/setMenu",
      toggleMenu: "app/toggleMenu",
    }),
  },
  created() {
    this.matchMediaMd.addListener(this.isMatchMedia);
  },
  async mounted() {
    this.calcResize();
  },
};
</script>

<style scoped lang="stylus">
.sidebar-logo {
  max-width: 25px;
}
</style>
